import Vue from 'vue';

export default class UploadLeadService extends Vue {

    private customActions = {
        uploadLead: { method: 'POST', url: 'lead/upload/upload-lead'},
        listUploadedLeads: { method: 'GET', url: 'lead/upload/get-list-upload'},
    };
    private resource: any = this.$resource('lead/upload', {}, this.customActions);

    public listUploadedLeads() {
        return this.resource.listUploadedLeads().then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

    public async uploadLead(params: any) {
        return await this.resource.uploadLead(params).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

}
